import { FormEvent, KeyboardEvent, useEffect, useRef, useState } from "react";

import { ArrowUp, Stop } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import Textarea from "ds/components/Textarea";
import useAssistantPanelStore from "components/AssistantPanel/Layout/useStore";

import styles from "./styles.module.css";

type AiChatComposerProps = {
  onSubmit: (message: string) => void;
  onStop: () => void;
  isStreaming: boolean;
  focusKey?: number;
};

const AiChatComposer = ({ onSubmit, onStop, isStreaming, focusKey }: AiChatComposerProps) => {
  const variant = useAssistantPanelStore((state) => state.variant);
  const [value, setValue] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, [variant, focusKey]);

  const submitMessage = () => {
    if (value.trim() && !isStreaming) {
      onSubmit(value.trim());
      setValue("");
    }
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    submitMessage();
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submitMessage();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box direction="column" gap="medium" padding="x-large">
        <Box
          direction="column"
          gap="medium"
          padding="medium"
          relative
          className={styles.messageBox}
        >
          <Textarea
            id="ai-chat-composer-textarea"
            ref={textareaRef}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ask Saturnhead AI anything..."
            className={styles.textarea}
            minRows={1}
          />
          <Box justify="end">
            {isStreaming ? (
              <ButtonIcon icon={Stop} variant="primary" onPress={onStop}>
                Stop generating
              </ButtonIcon>
            ) : (
              <ButtonIcon icon={ArrowUp} type="submit" variant="primary" disabled={!value.trim()}>
                Send message
              </ButtonIcon>
            )}
          </Box>
        </Box>
      </Box>
    </form>
  );
};

export default AiChatComposer;
